import React from 'react';

import './style.scss';

import { Div } from 'UIKit';

const Confetti = () => {
    return (
        <Div className={'ConfettiWrapper'}>
            <Div className="confetti-149" />
            <Div className="confetti-148" />
            <Div className="confetti-147" />
            <Div className="confetti-146" />
            <Div className="confetti-145" />
            <Div className="confetti-144" />
            <Div className="confetti-143" />
            <Div className="confetti-142" />
            <Div className="confetti-141" />
            <Div className="confetti-140" />
            <Div className="confetti-139" />
            <Div className="confetti-138" />
            <Div className="confetti-137" />
            <Div className="confetti-136" />
            <Div className="confetti-135" />
            <Div className="confetti-134" />
            <Div className="confetti-133" />
            <Div className="confetti-132" />
            <Div className="confetti-131" />
            <Div className="confetti-130" />
            <Div className="confetti-129" />
            <Div className="confetti-128" />
            <Div className="confetti-127" />
            <Div className="confetti-126" />
            <Div className="confetti-125" />
            <Div className="confetti-124" />
            <Div className="confetti-123" />
            <Div className="confetti-122" />
            <Div className="confetti-121" />
            <Div className="confetti-120" />
            <Div className="confetti-119" />
            <Div className="confetti-118" />
            <Div className="confetti-117" />
            <Div className="confetti-116" />
            <Div className="confetti-115" />
            <Div className="confetti-114" />
            <Div className="confetti-113" />
            <Div className="confetti-112" />
            <Div className="confetti-111" />
            <Div className="confetti-110" />
            <Div className="confetti-109" />
            <Div className="confetti-108" />
            <Div className="confetti-107" />
            <Div className="confetti-106" />
            <Div className="confetti-105" />
            <Div className="confetti-104" />
            <Div className="confetti-103" />
            <Div className="confetti-102" />
            <Div className="confetti-101" />
            <Div className="confetti-100" />
            <Div className="confetti-99" />
            <Div className="confetti-98" />
            <Div className="confetti-97" />
            <Div className="confetti-96" />
            <Div className="confetti-95" />
            <Div className="confetti-94" />
            <Div className="confetti-93" />
            <Div className="confetti-92" />
            <Div className="confetti-91" />
            <Div className="confetti-90" />
            <Div className="confetti-89" />
            <Div className="confetti-88" />
            <Div className="confetti-87" />
            <Div className="confetti-86" />
            <Div className="confetti-85" />
            <Div className="confetti-84" />
            <Div className="confetti-83" />
            <Div className="confetti-82" />
            <Div className="confetti-81" />
            <Div className="confetti-80" />
            <Div className="confetti-79" />
            <Div className="confetti-78" />
            <Div className="confetti-77" />
            <Div className="confetti-76" />
            <Div className="confetti-75" />
            <Div className="confetti-74" />
            <Div className="confetti-73" />
            <Div className="confetti-72" />
            <Div className="confetti-71" />
            <Div className="confetti-70" />
            <Div className="confetti-69" />
            <Div className="confetti-68" />
            <Div className="confetti-67" />
            <Div className="confetti-66" />
            <Div className="confetti-65" />
            <Div className="confetti-64" />
            <Div className="confetti-63" />
            <Div className="confetti-62" />
            <Div className="confetti-61" />
            <Div className="confetti-60" />
            <Div className="confetti-59" />
            <Div className="confetti-58" />
            <Div className="confetti-57" />
            <Div className="confetti-56" />
            <Div className="confetti-55" />
            <Div className="confetti-54" />
            <Div className="confetti-53" />
            <Div className="confetti-52" />
            <Div className="confetti-51" />
            <Div className="confetti-50" />
            <Div className="confetti-49" />
            <Div className="confetti-48" />
            <Div className="confetti-47" />
            <Div className="confetti-46" />
            <Div className="confetti-45" />
            <Div className="confetti-44" />
            <Div className="confetti-43" />
            <Div className="confetti-42" />
            <Div className="confetti-41" />
            <Div className="confetti-40" />
            <Div className="confetti-39" />
            <Div className="confetti-38" />
            <Div className="confetti-37" />
            <Div className="confetti-36" />
            <Div className="confetti-35" />
            <Div className="confetti-34" />
            <Div className="confetti-33" />
            <Div className="confetti-32" />
            <Div className="confetti-31" />
            <Div className="confetti-30" />
            <Div className="confetti-29" />
            <Div className="confetti-28" />
            <Div className="confetti-27" />
            <Div className="confetti-26" />
            <Div className="confetti-25" />
            <Div className="confetti-24" />
            <Div className="confetti-23" />
            <Div className="confetti-22" />
            <Div className="confetti-21" />
            <Div className="confetti-20" />
            <Div className="confetti-19" />
            <Div className="confetti-18" />
            <Div className="confetti-17" />
            <Div className="confetti-16" />
            <Div className="confetti-15" />
            <Div className="confetti-14" />
            <Div className="confetti-13" />
            <Div className="confetti-12" />
            <Div className="confetti-11" />
            <Div className="confetti-10" />
            <Div className="confetti-9" />
            <Div className="confetti-8" />
            <Div className="confetti-7" />
            <Div className="confetti-6" />
            <Div className="confetti-5" />
            <Div className="confetti-4" />
            <Div className="confetti-3" />
            <Div className="confetti-2" />
            <Div className="confetti-1" />
            <Div className="confetti-0" />
        </Div>
    );
};

export default Confetti;
